<template>
   
    <div> 
        <div class="crumbs" hidden="true"  style="margin-left:10px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 产品管理
                </el-breadcrumb-item>
                <el-breadcrumb-item>轮询配置</el-breadcrumb-item>
            </el-breadcrumb>
        </div>  
        <div class="container" >  
            <div class='leftItem'> 
                <el-radio-group v-model="itemVal">
                    <el-radio-button label="1">订单核对</el-radio-button>
                    <el-radio-button label="2">订单结算</el-radio-button>
                    <el-radio-button label="3">结算记录</el-radio-button> 
                </el-radio-group>  
            </div>
            <div class='contentItem' v-if="itemVal==1">
                <v-content1></v-content1>
            </div>
            <div class='contentItem' v-if="itemVal==2">
                <v-content2></v-content2>
            </div> 
        </div>     
          
    </div>
</template>

<script>
import $ from 'jquery';
import vContent1 from './CashGoodsWait.vue';
import vContent2 from './TaskList.vue'; 
export default {

    data() {
        return {  
           itemVal:'1', 
        };
    },
    created() {
         
    },
    //页面加载方法
    mounted: function () { 
        
    },
    components: { 
        vContent1,
        vContent2 
    },

    methods: {   
        
    }
};
</script>
 
